import React, { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import {
  setFocus,
  FocusContext,
} from '@noriginmedia/norigin-spatial-navigation'

import tts from '../../lib/TTS.js'
import FocusableButtonTS from '../../components/FocusableButton/FocusableButtonTS'
import { PLAYER_ERROR_CODES } from '../../../../shared/components/VideoPlayer/'

import type { LivePlayerErrorProps } from './types'
import { useHybridFocusable } from '../../hooks/useHybridFocusable'
import {
  KeyTypeEnum,
  useKeyDown,
} from '../../../../shared/providers/KeyDownProvider'

const BUTTON_KEY = 'BACK'

export const LivePlayerError = (props: LivePlayerErrorProps) => {
  const navigate = useNavigate()
  const { ref, focusKey } = useHybridFocusable({
    focusKey: 'PLAYER_ERROR',
  })
  const location = useLocation()
  const errorCode = new URLSearchParams(location.search).get('error-code')
  const errorDescription = `There was an error loading the livestream (Error: ${Object.keys(
    PLAYER_ERROR_CODES
  ).find(
    (key) =>
      PLAYER_ERROR_CODES[key as keyof typeof PLAYER_ERROR_CODES] === errorCode
  )}: ${errorCode})`
  const errorTitle = 'Live TV Playback Error'

  const handleEnterPress = () => {
    navigate('/livestream?fromChannelPlayback=true')
  }

  const handleFocus = () => {
    tts.enqueueTextToRead('Focus on Go back Button.')
  }

  // Workaround to allow new focus components to work with spatial navigation and old components work with focusable HoC
  // TODO: remove this when whole app is migrated to react spatial navigation
  useEffect(() => {
    window.focusedComponent = {}
    window.focusedComponent.handleBySpatialNavigation = true
    return () => {
      window.focusedComponent.handleBySpatialNavigation = false
    }
  }, [])

  useEffect(() => {
    if (props.isExternalFocused) {
      setFocus(BUTTON_KEY)
    } else {
      setFocus('')
    }
  }, [props.isExternalFocused])

  useEffect(() => {
    tts.addTextToRead(`${errorTitle} .... ${errorDescription}.`)
  }, [])

  useKeyDown([KeyTypeEnum.Back], () => {
    console.log('Back key pressed')
    handleEnterPress()
  })

  return (
    <FocusContext.Provider value={focusKey}>
      <div className="live-player-screen">
        <div className="live-player-screen__error" ref={ref}>
          <h1 className="live-player-screen__error__title">{errorTitle}</h1>
          <p className="live-player-screen__error__message">
            {errorDescription}
          </p>
          <FocusableButtonTS
            onEnterPress={handleEnterPress}
            onFocus={handleFocus}
            className="live-player-screen__error__back-button"
            focusKey={BUTTON_KEY}
          >
            Go back
          </FocusableButtonTS>
        </div>
      </div>
    </FocusContext.Provider>
  )
}
